import { UserRoleRoleEnum } from "./types/api";
import MyProfile from "./routes/MyProfile";
import Users from "./routes/Users";
import Organizations from "./routes/Organizations";
import AuditLog from "./routes/AuditLog";
import ApiClients from "./routes/ApiClients";
export var routesConfig = {
    myProfile: {
        path: "/my-profile",
        component: MyProfile,
    },
    users: {
        path: "/users",
        component: Users,
        roles: [UserRoleRoleEnum.AUTHORITY_ADMIN, UserRoleRoleEnum.USER_ADMIN],
    },
    organizations: {
        path: "/organizations",
        component: Organizations,
        roles: [UserRoleRoleEnum.AUTHORITY_ADMIN, UserRoleRoleEnum.USER_ADMIN],
    },
    auditLog: {
        path: "/audit-log",
        component: AuditLog,
        roles: [UserRoleRoleEnum.AUTHORITY_ADMIN],
    },
    apiClients: {
        path: "/api-clients",
        component: ApiClients,
        roles: [UserRoleRoleEnum.AUTHORITY_ADMIN],
    },
};
